import type { HelpEntry } from "./help.types";
import { VEHICLE_HELP_ENTRIES } from "@/features/vehicles/help/vehicle-help-entries";

/**
 * Every feature's help entries in one typed map. Each feature keeps its
 * entries next to the code they describe and adds them here; a key that isn't
 * registered is a compile error at the call site.
 */
const HELP_ENTRIES = {
	...VEHICLE_HELP_ENTRIES,
} satisfies Record<string, HelpEntry>;

/** `<feature>.<card>.<field>`, e.g. `vehicle.lifecycle.alwaysAvailable`. */
export type HelpKey = keyof typeof HELP_ENTRIES;

export function getHelpEntry(helpKey: HelpKey): HelpEntry {
	return HELP_ENTRIES[helpKey];
}
